import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatStepper } from '@angular/material/stepper';

@Component({
  selector: 'app-roadtax-blacklisted-dialog',
  templateUrl: './roadtax-blacklisted-dialog.component.html',
  styleUrls: ['./roadtax-blacklisted-dialog.component.scss']
})

export class RoadtaxBlacklistedDialogComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<RoadtaxBlacklistedDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { 
      stepper: MatStepper,
    }
  ) { }

  ngOnInit(): void {}

  closeDialog() {
    this.data.stepper.next();
    this.dialogRef.close();
  }
}
